module.exports = __webpack_public_path__ + "static/media/the_lao.d03e269c.svg";